module.exports = __webpack_public_path__ + "img/301.fe20b8ad.jpg";